__turbopack_context__.v({
  "banner-pattern": "HolidayPromoBanner-module-scss-module__cXnvwa__banner-pattern",
  "cta-button": "HolidayPromoBanner-module-scss-module__cXnvwa__cta-button",
  "left-promo-container": "HolidayPromoBanner-module-scss-module__cXnvwa__left-promo-container",
  "promo-code-expiry": "HolidayPromoBanner-module-scss-module__cXnvwa__promo-code-expiry",
  "promo-container": "HolidayPromoBanner-module-scss-module__cXnvwa__promo-container",
  "promo-text": "HolidayPromoBanner-module-scss-module__cXnvwa__promo-text",
  "promo-text-bolded": "HolidayPromoBanner-module-scss-module__cXnvwa__promo-text-bolded",
  "wrapper": "HolidayPromoBanner-module-scss-module__cXnvwa__wrapper",
});
